import styled from 'styled-components'
import { generateRGBAString } from '../../../utils/test-utils'

type StyledRadioButtonHolderProps = {
  backgroundColor?: string
  checkedColor?: string
  'data-testid'?: string
}

const StyledRadioButtonHolder = styled.div`
  ${(props: StyledRadioButtonHolderProps) =>
    props.checkedColor &&
    `   
        input:checked + label::before{
            background-color: ${props.checkedColor} !important;
            border-color: ${props.checkedColor} !important;
        }
        input:focus, input:active{
          box-shadow: 0 0 0 14px ${generateRGBAString(props.checkedColor, 10)} !important;
          border-color: ${props.checkedColor} !important;
        }
        input:focus:not(:disabled) + label::before {
          border-color: ${props.checkedColor} !important;
        }
    `}
  ${(props: StyledRadioButtonHolderProps) =>
    props.backgroundColor &&
    `
    label::after, label::before{
        background-color: ${props.backgroundColor} !important;
        border-color: ${props.checkedColor} !important;
    }`}
`

export default StyledRadioButtonHolder
